<template>
  <a-modal :centered="true" title="选择物料" width="80%"  v-model="visible" @cancel="closeFun" :before-close="closeFun" :footer="null" :body-style="{ padding: '10', height: '1000px' }">
    <div class="el-dialog-div1">
      <div class="dialog-left">
        <a-form-model class="UniformCss" label-width="80px" :inline="true">
          <a-row>
            <a-col :span="8">
              <a-form-model-item label="物料号">
                <a-input v-model="queryCondition.materialCode" clearable />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="物料名称">
                <a-input v-model="queryCondition.materialName" clearable />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="物料类型">
                <a-select v-model="queryCondition.materialType" clearable>
                  <a-select-option  value="1">销售物料</a-select-option>
                  <a-select-option  value="2" >礼品物料</a-select-option>
                  <a-select-option  value="3" >宣传物料</a-select-option>
                  <a-select-option  value="4" >其它</a-select-option>
                  <a-select-option  value="5" >产品资料</a-select-option>
                  <a-select-option  value="6" >手册</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <!-- <a-col :span="8">
              <a-form-model-item label="所属仓库">
                <a-select v-model="queryCondition.warehouse" clearable>
                  <a-select-option value="1">外部仓库</a-select-option>
                  <a-select-option value="2">内部仓库</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col> -->
            <!-- <a-col :span="8">
              <a-form-model-item label="新增时间">
                <a-date-picker valueFormat="YYYY-MM-DD" v-model="queryCondition.begindateStart" picker="date"  @change="queryCondition.enddateEnd ? (queryCondition.begindateEnd = '') : ''" />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="至">
                <a-date-picker valueFormat="YYYY-MM-DD" v-model="queryCondition.begindateEnd" picker="date" :picker-options="{ disabledDate: time => time.getTime() < new Date(queryCondition.begindateStart) - 8.64e7 }" />
              </a-form-model-item>
            </a-col> -->
          </a-row>
        </a-form-model>
        <div class="text-center">
          <vxe-button @click="resetForm()">重置</vxe-button>
          <vxe-button status="primary" @click="findPage(1)">查询</vxe-button>
        </div>
        <!-- lr009 -->
        <vxe-table
          ref="xTable"
          :loading="listLoading"
          align="center"
          :max-height="$store.state.app.height - 200 < 350 ? 350 : $store.state.app.height - 100"
          border
          show-header-overflow
          show-overflow
          class="mytable-scrollbar"
          :column-config="{ resizable: true }"
          stripe
          round
          :scroll-y="{ enabled: false }"
          :row-config="{ isHover: true }"
          :data="tableData"
        >
          <vxe-column type="checkbox" width="60" align="center" />
          <vxe-column type="seq" title="序号" width="60" align="center" />
          <vxe-column field="materialCode" title="物料号" width="200" />
          <vxe-column field="materialName" title="物料名称" width="300" />
          <vxe-column field="materialType" title="物料类型">
            <template #default="{ row }">
              <!-- <span v-if="row.materialType === '1'">销售物料</span>
              <span v-else-if="row.materialType === '2'">礼品物料</span>
              <span v-else-if="row.materialType === '3'">宣传物料</span>
              <span v-else-if="row.materialType === '4'">其它</span>
              <span v-else-if="row.materialType === '5'">产品资料</span>
              <span v-else-if="row.materialType === '6'">手册</span>
              <span v-else>其它</span> -->
              {{ row.materialType }}
            </template>
          </vxe-column>
          <vxe-column field="storage" title="库存量" />
          <vxe-column field="price" title="申领价" align="center">
            <template #default="{ row }">
              {{ row.price | toThousandNumFilter }}
            </template>
          </vxe-column>
          <!-- <vxe-column field="warehouse" title="所属仓库" width="100">
            <template #default="{ row }">
              <span v-if="row.warehouse === '1'">外部仓库</span>
              <span v-else-if="row.warehouse === '2'">内部仓库</span>
            </template>
          </vxe-column> -->
          <vxe-column title="操作" width="80" fixed="right" align="center" >
            <template #default="{ row }">
              <div class="operate">
                <a-button size="small" type="link" @click="picInfo(row)">查看图片</a-button>
              </div>
            </template>
          </vxe-column>
        </vxe-table>
        <!-- 看图弹框 -->
        <a-modal
            v-model="isModalVisible"
            title="查看图片"
            width="800px"
            @cancel="handleCancel"
            cancelText="关闭"
            :destrayOnClose="true"
        >
          <template slot="footer" >
            <a-button  @click="handleCancel">关闭</a-button>
          </template>
          <a-form>
            <a-row>
              <a-col>
                <a-form-item>
                  <div v-if="picList != null">
                    <div v-for=" (pic, index) in picList " :key="index" class="pic-box">
                      <el-image
                          style="width: 150px; height: 150px"
                          :src="pic"
                          :preview-src-list="picList"
                          fit="cover"
                      />
                    </div>
                  </div>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </a-modal>

        <div class="text-center">
          <vxe-pager
            :current-page="pagination.current"
            :page-size="pagination.size"
            :total="pagination.total"
            :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
            @page-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
    <div class="text-center">
      <vxe-button @click="closeFun()">返回</vxe-button>
      <vxe-button status="primary" @click="addMaterial()">添加</vxe-button>
    </div>
  </a-modal>
</template>
<script>
import {getImgs, getMaterialById, materialfindList} from '@/api/material'
import {setInitImg} from "@/utils/Picture/transferFile";

const defaultPagination = {
  total: 0,
  size: 10,
  current: 1
}

export default {
  name: 'SelectMaterialDialog',
  // eslint-disable-next-line vue/require-prop-types
  // props: ['visible', 'materialData'],cb0012
  props: ['visible'],

  data() {
    return {
      queryCondition: {
        storage: '1',
        isApply: '1'
      },
      tableData: [],
      pagination: Object.assign({}, defaultPagination),
      listLoading: false,
      multipleSelection: [],
      list: [],
      picList: [],
      sort: 'creater_date desc',
      isModalVisible: false
    }
  },
  computed: {
  },
  created() {
    this.findPage()
  },
  beforeMount() {},
  mounted() {},
  methods: {
    async findPage(e) {
      if (e) this.pagination.current = e
      // 筛选条件
      const queryData = {
        page: this.pagination.current,
        limit: this.pagination.size,
        ...this.queryCondition,
        sort: this.sort
      }
      this.listLoading = true // 开启加载动画
      materialfindList(queryData).then(res => {
        if (res.code === 1 && res.data) {
          this.tableData = res.data.list
          this.pagination.total = res.data.total
          this.listLoading = false
        } else {
          this.$message.error('查询失败')
        }
      })
    },

    // handleCurrentChange(val) {
    //   this.pagination.current = val
    //   this.findPage()
    // },

    handleCurrentChange({ currentPage, pageSize }) {
      // console.log(currentPage, pageSize,'---currentPage, pageSize----');
      
      this.pagination.current = currentPage
      if (pageSize != this.pagination.size) this.pagination.current = 1
      this.pagination.size = pageSize
      this.findPage()
    },
    resetForm() {
      this.queryCondition = {
        storage: '1',
        isApply: '1'
      }
      this.findPage(1)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    addMaterial() {       
      this.$emit('addMaterial', this.$refs.xTable.selection)
      this.$refs.xTable.clearCheckboxRow()
    },
    closeFun() {
      this.$refs.xTable.clearCheckboxRow()
      this.$emit('update:visible', false)
    },
    picInfo(row) {
      getMaterialById(row.materialId).then(res => {
        if (res.code === 1) {
          if (res.data.fileNames.length > 0) {
            this.fileNames = res.data.fileNames
            this.fileNames.forEach(name => {
              const data = {
                fileName: name,
                materialCode: row.materialCode
              }
              getImgs(data).then(res => {
                const file = setInitImg(res, name)
                this.picList.push(file.url)
              })
            })
          }
        }
      })
      this.isModalVisible = true
    },
    handleCancel(){
      this.isModalVisible = false
      this.picList = []
    }
  }
}
</script>
<style lang="less" scoped>
.el-dialog-div1{
  width: 100%;
}
.dialog-left {
  width: 98%;
}

.text-center {
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: center;
}

</style>
